var Base = /** @class */ (function () {
    function Base() {
    }
    Object.defineProperty(Base.prototype, "self", {
        get: function () {
            return this._self;
        },
        set: function (value) {
            this._self = value;
        },
        enumerable: false,
        configurable: true
    });
    Base.prototype.hide = function () {
        this.self.style.display = 'none';
    };
    Base.prototype.show = function () {
        this.self.style.display = '';
    };
    Base.prototype.focus = function () {
        this.self.focus();
    };
    return Base;
}());
export { Base };
